import { getCookie } from "./cookies";
import axios from "./axios";

const isToken = getCookie("auth_token");
const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

export default {
  dynamic: {
    getProfile() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/profile`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListPencipta(page, limit, status, keyword) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/get-list-song-writer`, {
            params: {
              page,
              limit,
              status,
              keyword
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSongList(page, limit, keyword = "") {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/song/get-list?page=${page}&limit=${limit}&keyword=${keyword}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Daftar permintaan pendaftaran lagu (pending & ditolak).
     *
     * Satu endpoint untuk dua sudut pandang — backend menentukannya dari peran
     * di token: publisher/admin mendapat pengajuan di katalognya, pencipta
     * mendapat pengajuannya sendiri beserta catatan penolakan.
     */
    getSongRequests(page = 1, limit = 10, keyword = "") {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/song/register-request`, {
            params: { page, limit, keyword },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSongDetail(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/song/detail/${id}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getRole() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/role`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListAdmin(page, limit) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/get-list-admin`, {
            params: {
              page,
              limit,
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getProjectType() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/project-type`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getGenre() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/genre`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getEra() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/era`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Daftar DSP untuk pilihan Asset ID. Sebelumnya dipatok di InfoLagu.js,
     * kini tabel referensi `publisher.rt_dsp`.
     */
    /**
     * Data master untuk memetakan laporan DSP: lagu (Work ID), Asset ID per DSP,
     * dan komposisi hak. Backend sudah membatasi cakupannya per peran —
     * songwriter hanya menerima lagu yang ia punya hak di dalamnya.
     */
    getDistributionMaster() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/report/distribution-master`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDsp() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/dsp`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCreator() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/creator`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getByRole(role, keyword = "", member, isAhliwaris) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${BASE_URL}/api/user/get-list?role_code=${role}&keyword=${keyword}${member ? `&member=${false}` : ''}&ahliWaris=${isAhliwaris}`
          )
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getPenciptaByUserId(userId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/anggota/${userId}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLisUserByRoleCode(role_code, keyword, ahliWaris) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/get-list`, {
            params: {
              role_code,
              keyword,
              ahliWaris
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAhliWarisByIdUser(userId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/heir/${userId}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAccess() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/access`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListTransaction() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/transaction/get-list`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getRoleById() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/roleById`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTransaction(page = 1, limit = 20, type) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/transaction/get-list`, {
            params: {
              page,
              limit,
              type
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSongByTitle(title) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/transaction/song?keyword=${title}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getIncomeReport(category_code, page, limit) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/report/income`, {
            params: {
              cat: category_code,
              page,
              limit,
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getIncomeDashboard() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/report/income/dashboard`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDistributionDashboard(page,  limit) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/report/distribution`, {
            params: {
              page,
              limit,
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDetailTransaksi(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/transaction/${id}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDashboard() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/dashboard`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDashboardList(page, limit) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/dashboard/list`, {
            params: {
              page: 1,
              limit: 7,
            },
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getReport(id, type) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/transaction/${type}/${id}`, {
            headers: {
              "Content-Type": "application/pdf",
            }
          })
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListBank() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/ref/bank`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getProfileById(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${BASE_URL}/api/user/anggota/${id}`)
          .then((response) => {
            const { data } = response.data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};
